import { breakpoints } from 'style'
import styled from 'styled-components'

export const HomeContainer = styled.div`
  @media (max-width: ${breakpoints.sm}px) {
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
